import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./Home";
import Jobs from "./Jobs";
import Groups from "./Groups";
import Store from "./Store";
import Shop from "./Shop";
import About from './about';
import Job from './Job';
import People from './People';
import Posts from './Posts';
import Learning from "./Learning";
import Login from "./Login";
import Header from "./Header";
import Pages from "./Pages";
import EditStore from "./EditStore";
import EditAbout from "./EditAbout";
import EditPosts from "./EditPosts";
import EditShop from "./EditShop";
import EditPeople from "./EditPeople";
import EditFollowers from "./EditFollowers";
import EditJobs from "./EditJobs";
import EditHome from "./EditHome";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import User from "./User";
import Cart from "./Cart";
import Resetpw from "./Resetpw";
import PrivateRoute from "./PrivateRoute";
import PostDetail from "./PostDetail";  // Import the PostDetail component
import Wishlist from "./Wishlist";
import Checkout from "./Checkout";
import Orders from "./Orders";
import Notifications from "./Notifications";
import CompleteProfile from "./CompleteProfile";
import SavedPosts from "./SavedPosts";
import Onboarding from "./Onboarding";

function Rout() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/pages" element={<PrivateRoute><Pages /></PrivateRoute>} />
            <Route path="/wishlist" element={<PrivateRoute><Wishlist /></PrivateRoute>} />
            <Route path="/Checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
            <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
            <Route path="/Notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
            {/* EditStore Route with nested child routes */}
            <Route path="/editstore" element={<PrivateRoute><EditStore /></PrivateRoute>}>
                <Route index element={<Navigate to="edithome" />} />
                <Route path="edithome" element={<EditHome />} />
                <Route path="editabout" element={<EditAbout />} />
                <Route path="editposts" element={<EditPosts />} />
                <Route path="editshop" element={<EditShop />} />
                <Route path="editpeople" element={<EditPeople />} />
                <Route path="editfollowers" element={<EditFollowers />} />
                <Route path="editjobs" element={<EditJobs />} /> 
            </Route>

            <Route path="/jobs" element={<PrivateRoute><Jobs /></PrivateRoute>} />
            <Route path="/groups" element={<PrivateRoute><Groups /></PrivateRoute>} />
             {/* Store Route with dynamic pageid */}
             <Route path="/store/:pageid" element={<PrivateRoute><Store /></PrivateRoute>}>
                <Route index element={<Navigate to="about" />} />
                <Route path="about" element={<About />} />
                <Route path="/store/:pageid/Posts" element={<Posts />} />
                <Route path="job" element={<Job />} />
                <Route path="people" element={<People />} />
            </Route>
            <Route path="/shop" element={<PrivateRoute><Shop /></PrivateRoute>} />
            <Route path="/learning" element={<PrivateRoute><Learning /></PrivateRoute>} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/user" element={<PrivateRoute><User /></PrivateRoute>} />
            <Route path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>} />
            <Route path="/resetpw" element={<Resetpw />} />
            <Route path="/post/:postId" element={<PrivateRoute><PostDetail /></PrivateRoute>} />
            <Route path="/CompleteProfile" element={<CompleteProfile />} />
            <Route path="/Home/:postid" element={<Home />} />
            <Route path="/saved" element={<SavedPosts />} />
            <Route path="/onboarding" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
        </Routes>
    );
}

export default Rout;